<template>
  <rest-page :fetch-endpoint="null">
    <page-header-new
      :breadcrumbs="breadcrumbs"
      :title="title"
      :description="description"
      :icon="integration.image"
    >
      <template slot="actions">
        <a
          v-if="integration.urls.guide"
          :href="integration.urls.guide"
          target="_blank"
        >
          <el-button type="primary" plain>
            {{ $t('Integrations_Button_Guide') }}
          </el-button>
        </a>

        <el-button
          type="primary"
          @click="saveIntegration"
          v-if="isFinalStep || !isStepped"
        >
          {{ $t('Integrations_Button_Connect') }}
        </el-button>
        <el-button
          type="primary"
          plain
          @click="next"
          v-if="!isFinalStep && isStepped"
          >{{ $t('Integrations_Button_Next') }}</el-button
        >
      </template>
    </page-header-new>

    <page-content>
      <integration-settings-form
        ref="form"
        :model="model"
        :integration="integration"
        :save-endpoint="saveEndpoint"
        :is-stepped="isStepped"
      ></integration-settings-form>
    </page-content>
  </rest-page>
</template>

<script>
import RestPage from '@/common/components/rest/RestPage'
import PageContent from '@/common/components/page/PageContent'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import Integrations from '@/modules/integrations/types'
import IntegrationSettingsForm from '@/modules/integrations/components/IntegrationSettingsForm'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import { EventBus } from '@/core/EventBus'
import RestApi from '@/core/services/RestApi'

export default {
  name: 'IntegrationCreatePage',

  components: {
    RestPage,
    PageContent,
    PageHeaderNew,
    IntegrationSettingsForm
  },
  mounted() {
    EventBus.$on('shopify-integration-form-final-step', newVal => {
      this.isFinalStep = newVal
    })

    if (this.$route.query.dynamic_integration_id) {
      RestApi(this.fetchEndpointDynamicIntegration).then(({ data }) => {
        this.model.name = data.name
        this.model.type = data.name
      })
    } else {
      this.model.name = this.$t(Integrations[this.$route.query.type].title)
    }
  },
  data() {
    return {
      isFinalStep: false,
      dynamicIntegration: {},
      model: {
        type: this.$route.query.type,
        project_id: this.$route.query.project_id,
        name: '',
        params: {},
        active: 1,
        dynamic_integration_id: this.$route.query.dynamic_integration_id
      }
    }
  },

  methods: {
    next() {
      EventBus.$emit('shopify-integration-form-next')
    },

    saveIntegration() {
      this.$refs['form'].save().then(model => {
        this.$store.dispatch('reloadProjectConfig')
        this.$router.push(this.redirectRoute(model))
      })
    },

    redirectRoute(model) {
      return projectRoute({
        name: 'IntegrationOverview',
        query: { id: model.id }
      })
    }
  },

  computed: {
    title() {
      let title = ''
      if (this.model.dynamic_integration_id) {
        title = this.model.type
      } else {
        title = this.$t(this.integration.title)
      }
      return this.$t('Integrations_Text_Connect') + ' ' + title
    },

    description() {
      return (
        this.$t(this.integration.category) +
        ' ' +
        this.$t('Integrations_Text_Integration')
      )
    },

    breadcrumbs() {
      return [
        {
          label: this.$t('Integrations_Breadcrumb_Settings')
        },
        {
          label: this.$t('Integrations_Breadcrumb_Integrations'),
          route: projectRoute({
            name: 'IntegrationsMarketplace'
          })
        },
        {
          label: this.$t('Integrations_Breadcrumb_ConnectNew')
        }
      ]
    },

    isStepped() {
      return this.integration.hasOwnProperty('steps')
    },

    saveEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `integrations`
      })
    },

    integration() {
      if (Integrations[this.$route.query.type] === undefined) {
        return Integrations['dynamicpromotions']
      }
      return Integrations[this.$route.query.type]
    },

    fetchEndpointDynamicIntegration() {
      return projectEndpoint({
        method: 'get',
        url:
          `integrations/dynamic-promotions/` + this.model.dynamic_integration_id
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/pages/IntegrationCreatePage.vue